import React from "react";
import { NetworkStatus } from "@apollo/client";
import { scrollToBottom } from "@hex-insights/core";
import { Message } from "../../../Utilities";
import { useEvictLastestMessagesCache } from "./cache";

export type UseMessageGroupScrollArgs = {
	data?: {
		messageConnection: {
			edges: { node: { id: Message["id"] } }[];
		};
	};
	networkStatus: NetworkStatus;
};

export function useMessageGroupScroll({ data, networkStatus }: UseMessageGroupScrollArgs) {
	const prevNetworkStatusRef = React.useRef(networkStatus);
	const justFinishedFetchingMore =
		prevNetworkStatusRef.current === NetworkStatus.fetchMore && networkStatus !== NetworkStatus.fetchMore;
	if (justFinishedFetchingMore) {
		preserveScrollPosition();
	}
	prevNetworkStatusRef.current = networkStatus;

	const mostRecentMessageID = data?.messageConnection.edges[(data?.messageConnection.edges.length ?? 0) - 1]?.node.id;
	const prevMostRecentMessageIDRef = React.useRef(mostRecentMessageID);

	React.useEffect(() => {
		// for when results are cached
		scrollToBottom();
		window.setTimeout(scrollToBottom, 0);
	}, []);

	React.useEffect(() => {
		scrollToBottom();
		window.setTimeout(scrollToBottom, 0);
		window.setTimeout(scrollToBottom, 100);
	}, [mostRecentMessageID]);

	const evictLatestMessagesCache = useEvictLastestMessagesCache();
	React.useEffect(() => {
		if (!!prevMostRecentMessageIDRef.current && mostRecentMessageID !== prevMostRecentMessageIDRef.current) {
			evictLatestMessagesCache();
		}
		prevMostRecentMessageIDRef.current = mostRecentMessageID;
	}, [mostRecentMessageID, evictLatestMessagesCache]);
}

export function preserveScrollPosition() {
	const scrollDistanceFromBottom = document.body.scrollHeight - window.scrollY;
	setTimeout(() => {
		window.scrollTo(0, document.body.scrollHeight - scrollDistanceFromBottom);
	}, 0);
}
